
import * as Yup from "yup";

export const formikAddMedia = {
  initialValues: {
    title: "",
    detailsDescription: "",
    category: "",
    subCategory: "",
    mediaType:"",
    files: [], 
    subCategoryIcon:[]
  },
  validationSchema: Yup.object({
    title: Yup.string().required("Required Field"),
    detailsDescription: Yup.string().required("Required Field"),
    category: Yup.string().required("Required Field"),
    subCategory: Yup.string().required("Required Field"),
  }),
};
